<ng-template #refresh>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>

<app-header-page>
    <h1>{{ 'HEADERS.FINANCE' | translate }}</h1>
</app-header-page>

<div class="totalPanel">
    <div *ngIf="forecastTotalData else loadingSmile" class="card mb-4 gbo_shadow" style="padding: 45px 3em">
        <ng-container *ngIf="forecastTotalData else loadingSmile">
            <div class="financeTotalSum">
                {{ financeTotalSum | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}
            </div>
        </ng-container>

        <h2 style="padding: 0; margin: 50px 0 0 0">{{ 'FINANCE.TEXT.CONTRACTS_LETTERS' | translate }}</h2>
        <div class="row financeApproveTotalSum">
            <div class="float-start p-4">
                {{ 'FINANCE.TEXT.INCOMING' | translate }}
                <div class="in">
                    {{ financeInTotalApproveSum | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}
                </div>
            </div>
            <div class="float-start p-4">
                {{ 'FINANCE.TEXT.OUTCOMING' | translate }}
                <div class="out">
                    {{ financeOutTotalApproveSum | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #createWalletView let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <div class="form-group">
            <h2>{{ 'MODALS.FIELDS.TITLE' | translate }}</h2>
            <input #walletTitle aria-describedby="emailHelp" class="form-control" id="walletName">
            <small class="form-text text-muted" id="walletHelp">{{ 'MODALS.TEXT.WALLET_NAME' | translate }}</small>

            <select class="form-select" disabled style="margin-top: 10px">
                <option>RUB</option>
            </select>
            <small class="form-text text-muted">{{ 'MODALS.TEXT.WALLET_CURRENCY' | translate }}</small>

            <button (click)="onCreateWallet(walletTitle.value, modal);" [disabled]="isLockButton"
                    class="btn btn-block btn-success"
                    data-action="createWalletButton">
                <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.CREATE' | translate }}</span>
            </button>
        </div>
    </div>
</ng-template>

<ng-template #virtualCardView let-modal>
    <app-button-modal-close [modal]="modal" modalSize="lg"></app-button-modal-close>
    <div [innerHTML]=" 'MODALS.TEXT.ALERT' | translate "
         class="modal-body"
    ></div>
</ng-template>

<!--
<app-doughnut-finance-chart
        [donutData]="donutData"
        [allTotal]="allTotal"
        [showDonut]="showDonut"
        [options]="options"
></app-doughnut-finance-chart>
-->

<div class="wallets master">
    <div *ngIf="masterWallet else loading" class="wallet" data-content="master">
        <app-master-wallet
                (emitRefresh)="onLoad()"
                [financeProfile]="financeProfile"
                [forecastData]="forecastData"

                [isLoadingDataError]="isLoadingDataError"
                [isLoadingData]="isLoadingData"

                [wallet]="masterWallet"
        ></app-master-wallet>
    </div>
</div>

<div class="row">
    <div [class.adaptiveContract]="adaptiveWalletType !== 'projectWallets'" class="wallets col-6">
        <div class="wallet">
            <div class="wallet-head hide displayInline">
                <h2>{{ 'FINANCE.TEXT.INTERNAL' | translate }}</h2>
            </div>
            <div class="btn-group btn-block adaptiveButtons">
                <div (click)="adaptiveWalletType = 'projectWallets'"
                     [ngStyle]="{background: adaptiveWalletType === 'projectWallets' ? 'rgb(151 104 19)' : ''}"
                     class="btn btn-success" data-action="projectWallets"
                     style="font-size: 12px; padding: 5px;">
                    {{ 'FINANCE.TEXT.INTERNAL' | translate }}
                </div>
                <div (click)="adaptiveWalletType = 'contractWallets'"
                     class="btn btn-success"
                     data-action="contractWallets"
                     style="font-size: 12px; padding: 5px; margin-left: 15px;">
                    {{ 'FINANCE.TEXT.CONTRACTS' | translate }}
                </div>
            </div>
        </div>
        <div class="btn-group btn-block">
            <button (click)="modalService.openTemplateModal(createWalletView)"
                    *ngIf="masterWallet"
                    class="btn btn-block btn-primary"
                    data-action="createWallet"> {{ 'FINANCE.BUTTONS.CREATE' | translate }}
            </button>
            <button (click)="modalService.openTemplateModal(virtualCardView)"
                    *ngIf="masterWallet"
                    class="btn btn-block btn-primary"
                    data-action="createVirtualCard"
                    style="margin-left: 5px; margin-top: 0"> {{ 'FINANCE.BUTTONS.VIRTUAL' | translate }}
            </button>
        </div>
        <div *ngFor="let wallet of slaveWallets; let i = index" [attr.data-wallet-index]="i" class="wallet">
            <app-slave-wallet
                    (emitRefresh)="onLoad()"
                    [financeProfile]="financeProfile"
                    [forecastData]="forecastData"
                    [i]="i"

                    [isLoadingDataError]="isLoadingDataError"
                    [isLoadingData]="isLoadingData"

                    [wallet]="wallet"
            ></app-slave-wallet>
        </div>
    </div>
    <div [class.adaptiveContract]="adaptiveWalletType !== 'contractWallets'" class="wallets col-6">
        <div class="wallet">
            <div class="wallet-head hide displayInline">
                <h2>{{ 'FINANCE.TEXT.CONTRACTS' | translate }}</h2>
            </div>
            <div class="btn-group btn-block adaptiveButtons">
                <div (click)="adaptiveWalletType = 'projectWallets'" class="btn btn-success"
                     data-action="projectWallets"
                     style="font-size: 12px; padding: 5px;">
                    {{ 'FINANCE.TEXT.INTERNAL' | translate }}
                </div>
                <div (click)="adaptiveWalletType = 'contractWallets'"
                     [ngStyle]="{background: adaptiveWalletType === 'contractWallets' ? 'rgb(151 104 19)' : ''}"
                     class="btn btn-success"
                     data-action="contractWallets"
                     style="font-size: 12px; padding: 5px; margin-left: 15px;">
                    {{ 'FINANCE.TEXT.CONTRACTS' | translate }}
                </div>
            </div>
        </div>

        <div *ngFor="let wallet of contractsWallets; let i = index" [attr.data-contract-wallet-index]="i"
             class="wallet">
            <app-slave-wallet
                    (emitRefresh)="onLoad()"
                    [financeProfile]="financeProfile"
                    [forecastData]="forecastData"
                    [i]="i"

                    [isLoadingDataError]="isLoadingDataError"
                    [isLoadingData]="isLoadingData"

                    [wallet]="wallet"
            ></app-slave-wallet>
        </div>
    </div>
</div>

<ng-template #loading>
    <app-component-loading></app-component-loading>
    <div *ngIf="isLoadingDataError" class="alert alert-danger">{{ 'CONNECTION_ERROR' | translate }}</div>
</ng-template>

<ng-template #loadingSmile>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>
